const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = '/employee';

const handleError = async (response, fallbackMessage = "حدث خطأ غير متوقع") => {
    let message = fallbackMessage;
    try {
        const data = await response.json();
        message = data?.message || data?.error || fallbackMessage;
    } catch (_) {
        try {
            const text = await response.text();
            message = text || fallbackMessage;
        } catch (_) {}
    }

    console.error(`API Error [${response.status}]: ${message}`);
    throw new Error(message);
};

export const getInstitutionEmployee = async (token) => {
    const response = await fetch(`${BASE_URL}${API_URL}/`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "حدث خطأ أثناء تحميل بيانات الموظفين");
    }

    return await response.json();
};

export const editEmployee = async (token, id, newData) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(newData),
    });

    if (!response.ok) {
        await handleError(response, "فشل في تعديل بيانات الموظف");
    }

    return await response.json();
};

export const deleteEmployee = async (token, id) => {
    const response = await fetch(`${BASE_URL}${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "فشل في حذف الموظف");
    }

    return await response.json();
};

export const nextTurnInQueue = async (token, queueId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/queue/next-turn`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ queueId }),
    });

    if (!response.ok) {
        await handleError(response, "فشل في جلب الدور التالي");
    }

    return await response.json();
};

export const getCurrentCustomer = async (token) => {
    const response = await fetch(`${BASE_URL}${API_URL}/queue/active-turn`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "فشل في تحميل العميل الحالي");
    }

    return await response.json();
};

export const endCurrentCustomer = async (token, queueId) => {
    const response = await fetch(`${BASE_URL}${API_URL}/queue/take-break`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ queueId }),
    });

    if (!response.ok) {
        await handleError(response, "فشل في إنهاء الموعد الحالي");
    }

    return true;
};

export const inviteEmployee = async (token, employeeData) => {
    const response = await fetch(`${BASE_URL}${API_URL}/register-with-invitation`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(employeeData),
    });

    if (!response.ok) {
        await handleError(response, "فشل إرسال دعوة الموظف");
    }

    return await response.json();
};

export const getBranchEmployee = async (token, branchId, name = '') => {
    const query = name ? `&name=${encodeURIComponent(name)}` : '';
    const response = await fetch(`${BASE_URL}${API_URL}?branchId=${branchId}${query}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!response.ok) {
        await handleError(response, "فشل تحميل بيانات موظفي الفرع");
    }

    return await response.json();
};

export const completeRegistration = async (email, name, password) => {
    const response = await fetch(`${BASE_URL}${API_URL}/complete-profile`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, name, password }),
    });

    if (!response.ok) {
        await handleError(response, "فشل إكمال التسجيل");
    }

    return await response.json();
};
